import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';
import { useAuth } from '../App';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || '/api';

const FLAGS = {
  FRA:'🇫🇷',ESP:'🇪🇸',ENG:'🏴󠁧󠁢󠁥󠁮󠁧󠁿',GER:'🇩🇪',POR:'🇵🇹',NED:'🇳🇱',BEL:'🇧🇪',
  CRO:'🇭🇷',AUT:'🇦🇹',SUI:'🇨🇭',SCO:'🏴󠁧󠁢󠁳󠁣󠁴󠁿',TUR:'🇹🇷',NOR:'🇳🇴',SWE:'🇸🇪',
  CZE:'🇨🇿',BIH:'🇧🇦',ARG:'🇦🇷',BRA:'🇧🇷',USA:'🇺🇸',MEX:'🇲🇽',CAN:'🇨🇦',
  URU:'🇺🇾',COL:'🇨🇴',ECU:'🇪🇨',PAR:'🇵🇾',PAN:'🇵🇦',HAI:'🇭🇹',CUW:'🇨🇼',
  MAR:'🇲🇦',SEN:'🇸🇳',EGY:'🇪🇬',NGA:'🇳🇬',CIV:'🇨🇮',GHA:'🇬🇭',RSA:'🇿🇦',
  TUN:'🇹🇳',ALG:'🇩🇿',CMR:'🇨🇲',COD:'🇨🇩',JPN:'🇯🇵',KOR:'🇰🇷',IRN:'🇮🇷',
  SAU:'🇸🇦',AUS:'🇦🇺',QAT:'🇶🇦',UZB:'🇺🇿',NZL:'🇳🇿',IRQ:'🇮🇶',JOR:'🇯🇴',CPV:'🇨🇻',
};

function Flag({ code, size = 36 }) {
  return <span style={{fontSize: size, lineHeight:1}}>{FLAGS[code] || '🏳'}</span>;
}

function pts_color(p) {
  if (p === 10) return 'var(--success)';
  if (p >= 5)  return 'var(--accent)';
  if (p >= 3)  return 'var(--accent2)';
  if (p === -1) return 'var(--muted)';
  return 'var(--danger)';
}

export default function MyPronos() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [pronos, setPronos] = useState([]);
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { navigate('/login'); return; }
    Promise.all([
      axios.get(`${API}/pronos/me`),
      axios.get(`${API}/me`),
    ]).then(([p, m]) => { setPronos(p.data); setMe(m.data); })
      .finally(() => setLoading(false));
  }, [user, navigate]);

  if (!user) return null;

  return (
    <div className="container" style={{padding:'32px 20px'}}>
      <h2 className="section-title">🎯 Mes <span>pronos</span></h2>

      {me && (
        <div className="grid-2" style={{marginBottom:24}}>
          {[
            ['🏆 Points', me.points, 'var(--accent)'],
            ['🎯 Pronos joués', me.pronos, 'var(--text)'],
            ['✅ Précision', `${me.accuracy}%`, 'var(--success)'],
          ].map(([l, v, c]) => (
            <div key={l} className="card" style={{padding:'20px 24px'}}>
              <div style={{fontSize:12,color:'var(--muted)',marginBottom:4}}>{l}</div>
              <div style={{fontFamily:'var(--font-head)',fontSize:'2rem',color:c,letterSpacing:1}}>{v}</div>
            </div>
          ))}
        </div>
      )}

      <div className="card">
        {loading ? <div className="spinner" /> : pronos.length === 0
          ? <div className="empty">Aucun prono encore — <a href="/" style={{color:'var(--accent)'}}>Voir les matchs</a></div>
          : pronos.map(p => {
            const ko = p.kickoff ? format(parseISO(p.kickoff), "d MMM · HH'h'mm", {locale:fr}) : '';
            return (
              <div key={p.match_id} style={{
                display:'grid',
                gridTemplateColumns:'1fr auto 1fr auto',
                alignItems:'center',
                gap:12,
                padding:'16px 20px',
                borderBottom:'1px solid var(--border)',
              }}>
                <div style={{display:'flex',alignItems:'center',gap:10}}>
                  <Flag code={p.home.code} size={32} />
                  <div>
                    <div style={{fontWeight:600,fontSize:14}}>{p.home.name}</div>
                    <div style={{fontSize:11,color:'var(--muted)'}}>{ko}</div>
                  </div>
                </div>
                <div style={{textAlign:'center'}}>
                  <div style={{
                    fontFamily:'var(--font-head)',fontSize:'1.6rem',
                    letterSpacing:3,color:'var(--accent)'
                  }}>
                    {p.prediction.home} — {p.prediction.away}
                  </div>
                  <div style={{fontSize:11,color:'var(--muted)'}}>Mon prono</div>
                </div>
                <div style={{display:'flex',alignItems:'center',gap:10,justifyContent:'flex-end'}}>
                  <div style={{textAlign:'right'}}>
                    <div style={{fontWeight:600,fontSize:14}}>{p.away.name}</div>
                  </div>
                  <Flag code={p.away.code} size={32} />
                </div>
                <div style={{textAlign:'center',minWidth:52}}>
                  {p.points === -1
                    ? <span style={{fontSize:12,color:'var(--muted)'}}>⏳</span>
                    : <div>
                        <div style={{fontFamily:'var(--font-head)',fontSize:'1.4rem',color:pts_color(p.points)}}>
                          {p.points}
                        </div>
                        <div style={{fontSize:10,color:'var(--muted)'}}>pts</div>
                      </div>
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
}
